(() => {
  const dialog = document.getElementById('njt-fitment-reminder');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const hasSelectedVehicle = () => {
    const valid = value => typeof value === 'string' && value.trim() !== '' && value.trim().toUpperCase() !== 'VEHICLE';
    const selected = new URLSearchParams(location.search).get('filter.p.m.organizer.car_models');
    if (valid(selected)) return true;
    try {
      const vehicle = JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null');
      return valid(vehicle?.vehicleName);
    } catch (_) {
      return false;
    }
  };
  let pending = null;
  let accepted = false;
  const invalidate = () => { accepted = false; };
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items,cart-drawer-items,#cart,#CartDrawer-Form')) invalidate();
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, invalidate);
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = event.submitter;
    if (!['cart', 'CartDrawer-Form'].includes(form.id) || button?.name !== 'checkout' || accepted || hasSelectedVehicle()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    pending = {formId: form.id, buttonId: button.id, button};
    dialog.showModal();
  }, true);
  dialog.querySelector('[data-njt-fitment-review]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    if (pending) pending.button.focus({preventScroll:true});
    pending = null;
  });
  dialog.querySelector('[data-njt-fitment-continue]').addEventListener('click', () => {
    const target = pending;
    if (!target) return;
    const form = document.getElementById(target.formId);
    const button = document.getElementById(target.buttonId) || target.button;
    if (!form || !button.isConnected || button.disabled) { dialog.close(); return; }
    accepted = true;
    pending = null;
    dialog.close();
    form.requestSubmit(button);
  });
})();
